module.exports = __webpack_public_path__ + "static/media/23GalleryPuppets.378e42ee.jpeg";